// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .choice-setup-dialog-content .mat-dialog-container {
  width: 1000px;
}

::ng-deep .choice-setup-dialog-header .mat-dialog-title {
  margin: 0 0 10px;
}

::ng-deep .choice-setup-dialog-content {
  min-width: 20vw;
  max-width: 1137px;
}

.display-none {
  display: none;
}

.choice-setup-container {
  max-height: calc(65vh - 100px);
  overflow: auto;
  table-layout: fixed;
}
.choice-setup-container table {
  margin-bottom: 4px;
  border-collapse: separate;
  border-spacing: 0;
}

.cus-matchip {
  min-height: 1px !important;
  align-self: center;
  font-size: 12px;
  color: white !important;
}

.block-section {
  display: flex;
  justify-content: space-between;
}

.choice-setup-container .mat-table-sticky {
  cursor: pointer;
  opacity: 1;
}

.cdk-drop-list-dragging .cdk-drag {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.cdk-drag-preview {
  opacity: 0;
}

th.mat-header-cell {
  text-align: center;
}

th.mat-header-cell:first-of-type, td.mat-cell:first-of-type, td.mat-footer-cell:first-of-type {
  padding-left: 1px;
}

.mat-table tr.mat-row:hover,
.mat-table .mat-row:hover {
  cursor: pointer;
  background-color: white;
}

.choice-setup-dialog-header .mat-dialog-title {
  display: flex;
  justify-content: space-between;
}

.mat-menu-item .mat-icon {
  color: orange;
  margin-right: 8px;
}

.menu-tool {
  display: none;
  position: absolute;
  left: 55px;
  top: 24px;
  background: whitesmoke;
  border-radius: 5px;
}
.menu-tool mat-icon {
  font-size: 17px;
  height: 17px;
}
.menu-tool mat-icon:hover {
  background-color: wheat;
}

.menu-disabled {
  display: none;
}

.menu-show {
  display: block;
}

.menu-tricker {
  width: 15%;
  color: gray;
  align-self: flex-end;
  right: 27%;
  margin-bottom: -7px;
}

.trigger {
  height: 40px;
}

.td-select {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 5px;
}

.header-menu {
  display: flex;
}
.header-menu mat-select {
  align-self: center;
}
.header-menu mat-icon {
  font-size: medium;
  height: 26px;
}
.header-menu .mat-icon-button {
  width: auto;
}

.add-menus-bar {
  position: sticky;
  left: 0;
}
.add-menus-bar button {
  width: 100%;
  border-style: solid;
  border-width: 1px;
  margin-top: 3px;
  height: 30px;
}

.error-hint {
  font-size: 11px;
  color: white;
  background: #b71c1c;
  width: 100%;
  margin-left: 10px;
  border-radius: 4px;
}

.body-value-column {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.body-value-column .mat-form-field {
  width: 100%;
}

.menus-items-value {
  display: flex;
  flex-direction: column;
  margin: -10px 5px 0px -20px;
  border: solid 1px ghostwhite;
  border-bottom: none;
  border-top: none;
  border-left: none;
  height: 40px;
}
.menus-items-value mat-icon {
  font-size: 14px;
}
.menus-items-value button:last-child {
  margin-top: 5px;
}

.menus-item-2 {
  margin-top: 10px;
  display: flex;
  margin-top: 2px;
}

.small-icon-button {
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
}
.small-icon-button .mat-icon {
  width: 13px !important;
  height: 13px !important;
  line-height: 13px !important;
}
.small-icon-button .mat-icon:hover {
  background-color: darkgray;
  border-radius: 10px;
}
.small-icon-button .material-icons {
  font-size: 14px !important;
}

#dl-choice-setup-dragdrop-zone th {
  background: #80d9e4;
  border-left: 2.5px solid white;
  border-bottom: none;
}

#dl-choice-setup-dragdrop-zone th:first-child {
  border-left: none;
}

:host .mat-menu-panel .mat-menu-item {
  width: 100%;
}

.mat-footer-row,
.mat-header-row,
.mat-row {
  min-width: 100%;
}

.dl-choice-setup-menu {
  margin-top: -5px;
  display: flex;
  flex-direction: column;
}

.header-menu:hover .menu-tool {
  display: block;
}

::ng-deep .choice-setup-container .mat-form-field-label {
  font-size: 11px !important;
  font-weight: bold;
}

::ng-deep .choice-setup-container .mat-table td.mat-cell {
  border: none;
}

::ng-deep .choice-setup-container .mat-form-field-wrapper {
  margin: 0px !important;
}

::ng-deep .choice-setup-container .mat-form-field-appearance-outline .mat-form-field-infix {
  font-size: 11px !important;
  padding: 8px 1px !important;
  line-height: 1;
  margin-top: -5px;
}

::ng-deep .choice-setup-container .mat-form-field-appearance-outline .mat-form-field-flex {
  margin-top: 1px;
}

::ng-deep .choice-setup-container th.mat-header-cell:last-of-type, td.mat-cell:last-of-type, td.mat-footer-cell:last-of-type {
  padding: 0px;
}

::ng-deep .choice-setup-container .mat-table td.mat-cell, .mat-table td.mat-footer-cell, .mat-table th.mat-header-cell {
  padding: 0 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/dialog/choice-setup/choice-setup.component.scss"],"names":[],"mappings":"AAAA;EACG,aAAA;AACH;;AAEA;EACG,gBAAA;AACH;;AAEA;EACG,eAAA;EACA,iBAAA;AACH;;AAEA;EACG,aAAA;AACH;;AAEA;EACG,8BAAA;EACA,cAAA;EACA,mBAAA;AACH;AAAG;EACG,kBAAA;EACA,yBAAA;EACA,iBAAA;AAEN;;AAEA;EACG,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;AACH;;AAEA;EACG,aAAA;EACA,8BAAA;AACH;;AAEA;EACG,eAAA;EACA,UAAA;AACH;;AAEA;EACG,sDAAA;AACH;;AAEA;EACG,UAAA;AACH;;AAEA;EACG,kBAAA;AACH;;AAEA;EACI,iBAAA;AACJ;;AAEA;;EAEG,eAAA;EACA,uBAAA;AACH;;AAGG;EACG,aAAA;EACA,8BAAA;AAAN;;AAIA;EACG,aAAA;EACA,iBAAA;AADH;;AAIA;EACG,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;AADH;AAGG;EACG,eAAA;EACA,YAAA;AADN;AAIG;EACG,uBAAA;AAFN;;AAMA;EACG,aAAA;AAHH;;AAMA;EACG,cAAA;AAHH;;AAMA;EACG,UAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;EACA,mBAAA;AAHH;;AAMA;EACG,YAAA;AAHH;;AAMA;EACG,aAAA;EACC,mBAAA;EACA,uBAAA;EACA,eAAA;AAHJ;;AAMA;EACG,aAAA;AAHH;AAKG;EACG,kBAAA;AAHN;AAMG;EACG,iBAAA;EACA,YAAA;AAJN;AAOG;EACG,WAAA;AALN;;AASA;EACG,gBAAA;EACA,OAAA;AANH;AAOG;EACG,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AALN;;AASA;EACG,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AANH;;AASA;EACG,aAAA;EACA,mBAAA;EACA,8BAAA;AANH;AAOG;EACG,WAAA;AALN;;AASA;EACG,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AANH;AAOG;EACG,eAAA;AALN;AAOG;EACG,eAAA;AALN;;AASA;EACG,gBAAA;EACA,aAAA;EACA,eAAA;AANH;;AASA;EACG,sBAAA;EACA,uBAAA;EACA,4BAAA;AANH;AAQG;EACG,sBAAA;EACA,uBAAA;EACA,4BAAA;AANN;AASG;EACE,0BAAA;EACD,mBAAA;AAPJ;AASG;EACG,0BAAA;AAPN;;AAWA;EACG,mBAAA;EACA,8BAAA;EACA,mBAAA;AARH;;AAWA;EACG,iBAAA;AARH;;AAWA;EACG,WAAA;AARH;;AAWC;;;EAGG,eAAA;AARJ;;AAWA;EACG,gBAAA;EACA,aAAA;EACA,sBAAA;AARH;;AAWA;EACG,cAAA;AARH;;AAWA;EACG,0BAAA;EACA,iBAAA;AARH;;AAWA;EACG,YAAA;AARH;;AAWA;EACG,sBAAA;AARH;;AAWA;EACG,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,gBAAA;AARH;;AAWA;EACG,eAAA;AARH;;AAWA;EACG,YAAA;AARH;;AAWA;EACG,yBAAA;AARH","sourcesContent":["::ng-deep .choice-setup-dialog-content .mat-dialog-container {\n   width: 1000px;\n}\n\n::ng-deep .choice-setup-dialog-header .mat-dialog-title {\n   margin: 0 0 10px;\n}\n\n::ng-deep .choice-setup-dialog-content {\n   min-width: 20vw;\n   max-width: 1137px;\n}\n\n.display-none {\n   display: none;\n}\n\n.choice-setup-container {\n   max-height: calc(65vh - 100px);\n   overflow: auto;\n   table-layout: fixed;\n   table {\n      margin-bottom: 4px;\n      border-collapse: separate;\n      border-spacing: 0;\n   }\n}\n\n.cus-matchip {\n   min-height: 1px !important;\n   align-self: center;\n   font-size: 12px;\n   color: white !important;\n}\n\n.block-section {\n   display: flex;\n   justify-content: space-between;\n}\n\n.choice-setup-container .mat-table-sticky {\n   cursor: pointer;\n   opacity: 1;\n}\n\n.cdk-drop-list-dragging .cdk-drag {\n   transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n }\n\n.cdk-drag-preview {\n   opacity: 0;\n}\n\nth.mat-header-cell {\n   text-align: center;\n}\n\nth.mat-header-cell:first-of-type, td.mat-cell:first-of-type, td.mat-footer-cell:first-of-type {\n    padding-left: 1px;\n}\n\n.mat-table tr.mat-row:hover,\n.mat-table .mat-row:hover {\n   cursor: pointer;\n   background-color: white;\n}\n\n.choice-setup-dialog-header {\n   .mat-dialog-title {\n      display: flex;\n      justify-content: space-between;\n   }\n}\n\n.mat-menu-item .mat-icon {\n   color: orange;\n   margin-right: 8px;\n}\n\n.menu-tool {\n   display: none;\n   position: absolute;\n   left: 55px;\n   top: 24px;\n   background: whitesmoke;\n   border-radius: 5px;\n\n   mat-icon {\n      font-size: 17px;\n      height: 17px;\n   }\n\n   mat-icon:hover {\n      background-color: wheat;\n   }\n}\n\n.menu-disabled {\n   display: none;\n}\n\n.menu-show {\n   display: block;\n}\n\n.menu-tricker {\n   width: 15%;\n   color: gray;\n   align-self: flex-end;\n   right: 27%;\n   margin-bottom: -7px;\n}\n\n.trigger {\n   height: 40px;\n}\n\n.td-select {\n   display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin-top: 5px;\n}\n\n.header-menu {\n   display: flex;\n\n   mat-select {\n      align-self: center;\n   }\n\n   mat-icon {\n      font-size: medium;\n      height: 26px;\n   }\n\n   .mat-icon-button {\n      width: auto;\n   }\n}\n\n.add-menus-bar {\n   position: sticky;\n   left: 0;\n   button {\n      width: 100%;\n      border-style: solid;\n      border-width: 1px;\n      margin-top: 3px;\n      height: 30px;\n   }\n}\n\n.error-hint {\n   font-size: 11px;\n   color: white;\n   background: #b71c1c;\n   width: 100%;\n   margin-left: 10px;\n   border-radius: 4px;\n}\n\n.body-value-column {\n   display : flex;\n   flex-direction: row;\n   justify-content: space-between;\n   .mat-form-field {\n      width: 100%;\n   }\n}\n\n.menus-items-value {\n   display: flex;\n   flex-direction: column;\n   margin: -10px 5px 0px -20px;\n   border: solid 1px ghostwhite;\n   border-bottom: none;\n   border-top: none;\n   border-left: none;\n   height: 40px;\n   mat-icon {\n      font-size: 14px;\n   }\n   button:last-child {\n      margin-top: 5px;\n   }\n}\n\n.menus-item-2 {\n   margin-top: 10px;\n   display: flex;\n   margin-top: 2px;\n}\n\n.small-icon-button {\n   width: 16px !important;\n   height: 16px !important;\n   line-height: 16px !important;\n\n   .mat-icon {\n      width: 13px !important;\n      height: 13px !important;\n      line-height: 13px !important;\n   }\n\n   .mat-icon:hover {\n     background-color: darkgray;\n    border-radius: 10px;\n   }\n   .material-icons {\n      font-size: 14px !important;\n   }\n}\n\n#dl-choice-setup-dragdrop-zone th {\n   background: #80d9e4;\n   border-left: 2.5px solid white;\n   border-bottom: none;\n}\n\n#dl-choice-setup-dragdrop-zone th:first-child {\n   border-left: none;\n}\n\n:host .mat-menu-panel .mat-menu-item {\n   width: 100%;\n}\n\n .mat-footer-row,\n.mat-header-row,\n.mat-row {\n    min-width: 100%;\n}\n\n.dl-choice-setup-menu {\n   margin-top: -5px;\n   display: flex;\n   flex-direction: column;\n}\n\n.header-menu:hover .menu-tool {\n   display: block;\n}\n\n::ng-deep .choice-setup-container .mat-form-field-label {\n   font-size: 11px !important;\n   font-weight: bold;\n}\n\n::ng-deep .choice-setup-container .mat-table td.mat-cell {\n   border: none;\n}\n\n::ng-deep .choice-setup-container .mat-form-field-wrapper {\n   margin: 0px !important;\n}\n\n::ng-deep .choice-setup-container .mat-form-field-appearance-outline .mat-form-field-infix {\n   font-size: 11px !important;\n   padding: 8px 1px !important;\n   line-height: 1.00;\n   margin-top: -5px;\n}\n\n::ng-deep .choice-setup-container .mat-form-field-appearance-outline .mat-form-field-flex {\n   margin-top: 1px;\n}\n\n::ng-deep .choice-setup-container th.mat-header-cell:last-of-type, td.mat-cell:last-of-type, td.mat-footer-cell:last-of-type {\n   padding: 0px;\n}\n\n::ng-deep .choice-setup-container .mat-table td.mat-cell, .mat-table td.mat-footer-cell, .mat-table th.mat-header-cell {\n   padding: 0 2px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
